import React from "react";
import { useApiClient } from "../../../shared/customHooks";
import { assignStatusForm } from "../../../shared/formObjects/application/assignStatusForm";
import { useApplicationContext } from "../context/applicationContext";
import BaseApplicationComponent from "../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";

export default function AssignStatusComponent({ disabled, data }: any) {
  const formApi = useApiClient("AssignStatus");
  const { id } = useApplicationContext();

  return (
    <>
      {" "}
      <BaseApplicationComponent
        formBody={assignStatusForm}
        headerLabel="Assign a Status"
        editPath="assignstatus"
        apiClient={formApi}
        disabled={disabled}
        data={data}
        id={id}
      />
    </>
  );
}
